import { useState, useEffect, useRef, useCallback } from "react";
import scroll_down from "../../_assets/images/scroll_down.png";
import scroll_down3 from "../../_assets/images/scroll_down3.png";
import scroll_down4 from "../../_assets/images/scroll_down4.png";
import { MainContainer, Container } from "../ComponentCss";
import { MarriageCommonComponent } from "../CommonComponent";
import FooterComponent from "../FooterComponent";
import { useLocation } from "react-router-dom";

const MarriageComponent = ({ playState, setSpyEle, setBgIsBlack, setSupportVisible, marrEleRef }) => {        
    const audioRef = useRef();
    const componentRef = useRef([]);
    const componentContRef = useRef();
    const [eleScrollTop, setEleScrollTop] = useState([]);
    const [eleScrollBottom, setEleScrollBottom] = useState();
    const [selectComponent, setSelectComponent] = useState(0);

    const location = useLocation();

    const play = () => { audioRef.current.play(); };
    const pause = () => { audioRef.current.pause(); };

    useEffect(() => {        
        if (location.search.indexOf('marriage') > -1) {
            setSpyEle('marriage');
            play();
        }
    }, [location, setSpyEle])

    useEffect(() => {
        if (playState === "marriage") {
            // 각 element의 top값을 귀하기 위함
            const eleTopArray = componentRef.current.map(ele => ele.getBoundingClientRect().top + window.pageYOffset);
            const eleTop = componentContRef.current.getBoundingClientRect().top + window.pageYOffset;
            const eleIndex = eleTopArray.indexOf(eleTop);
            setEleScrollTop(eleTopArray);
            setEleScrollBottom(componentContRef.current.getBoundingClientRect().bottom + window.pageYOffset);
            setSelectComponent(eleIndex);
        } else {
            pause();
        }
    }, [playState]); 

    const scrollHandler = useCallback(() => {
        // 로고, 버튼 색 변경을 위함
        if (eleScrollTop.length > 0) {
            let scrollY = window.scrollY + 100;
            const eleArr = eleScrollTop.filter(ele => scrollY >= ele);
            const eleIdx = eleScrollTop.indexOf(eleArr[eleArr.length-1]);
            if (eleIdx > -1) setSelectComponent(eleIdx);            
            if (scrollY > eleScrollTop[2] + window.innerHeight) {
                pause();
            } 
            if (scrollY < eleScrollTop[0]) {
                setSpyEle('');
            } else if (scrollY < eleScrollBottom) {
                setSpyEle('marriage');
            } else if (scrollY > eleScrollBottom) {
                setSpyEle('');
            } else {
                setSpyEle('marriage')
            }
        }
    }, [eleScrollBottom, eleScrollTop, setSpyEle]);

    useEffect(() => {
        window.addEventListener("scroll", scrollHandler);
        return () => {
        window.removeEventListener("scroll", scrollHandler);
        };
    }, [scrollHandler]);

    // 현재 보여지는 component가 변할때마다 scroll이동
    useEffect(() => {
        const audioPart = [{'s': 0, 'e': 6}, {'s': 7, 'e': 16}, {'s': 17, 'e': 30}];

        if (selectComponent !== null && playState === "marriage") {
            if (selectComponent < 3) {
                audioRef.current.currentTime = audioPart[selectComponent]['s'];
                play();
    
                const scrollInto = setInterval(() => {         
                    let currentTime = parseInt(audioRef.current.currentTime);
                    if (audioPart[selectComponent]['e'] === currentTime) {
                        componentRef.current[selectComponent+1].scrollIntoView({behavior: "smooth"});
                    }
                }, 1000);        
                return () => clearInterval(scrollInto);
            } else {   
                pause();
            }
        }
    }, [playState, selectComponent]);

    return (
        <>
            <section id="marriage" ref={ marrEleRef }>
                <MainContainer ref={ componentContRef } style={{ position: 'relative'}} spyEle={ playState }>
                    <audio preload="auto" loop={ false } src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/marriage_EFX.721dd64e51257ee1e647.mp3" } ref={ audioRef } style={{ position: 'fixed', top: 65,  zIndex: '1000000'}} />
                    <Container className="p-1-m" ref={ el => componentRef.current[0] = el }>
                        <div className="comm">
                            당신은 친언니 밀락과 함께 <br className="mo" />방에 있습니다.
                        </div>
                        <img src={ scroll_down } alt="scroll down 이미지" className="scroll_img" />                
                        <span className="copyright">©UNICEF/ UN0227010</span>
                    </Container>
                    <Container className="p-1-m" ref={ el => componentRef.current[1] = el }>
                        <div className="comm">
                            언니가 갑자기 <br className="mo" />흐느끼기 시작합니다.
                        </div>
                        <img src={ scroll_down } alt="scroll down 이미지" className="scroll_img" />               
                        <span className="copyright">©UNICEF/ UN0227010</span>
                    </Container>
                    <Container className="p-3" ref={ el => componentRef.current[2] = el }>
                        <div className="comm">
                            알고 보니 오늘은 11살 언니 밀락이<br/>
                            얼굴도 모르는 54세 남자와의<br/>
                            강제 결혼을 위해<br/>
                            집을 떠나는 날이었습니다.
                        </div>                
                        <div className="scroll-cont" style={{ alignSelf: "center" }}>
                            <p>
                                스크롤을 내려 밀락의 이야기 들어보기
                            </p>
                            <img src={ scroll_down4 } alt="scroll down 이미지" className="pc" />
                            <img src={ scroll_down3 } alt="scroll down 이미지" className="mo" />
                        </div>
                    </Container>
                    <MarriageCommonComponent marriRef={ componentRef.current[3] } marriRef2={ eleScrollTop[2] } setBgIsBlack={ setBgIsBlack } playState={ playState } setSpyEle={ setSpyEle } setSupportVisible={ setSupportVisible } />
                </MainContainer>
            </section>
            <FooterComponent status={ playState } setSpyEle={ setSpyEle } />
        </>
    );
}

export default MarriageComponent;
